<!-- class_state 0--正常 1--没在库里 2--进价低 3--进价高 -->
<template>
  <div class="fa">
    <div>
      <div class="l-title">
        线上类别
      </div>
      <dyhOnlineclass :width="220" :btnshow="false"></dyhOnlineclass>
    </div>
    <div class="main-right">
      <div>
        <div class="top-btn">
          <dyh-goods-search
            ref="dyhgoodssearchRef"
            @getGoods="getGoods"
            @dyhGoodsSearchReturn="dyhGoodsSearchReturn"
            :who="'goodsinfo'"
          ></dyh-goods-search>

          <div style="width:450px;text-align: right;">
            <!-- <el-button size="mini" @click="changeClass" type="primary"
            >基本类别</el-button
          > -->
            <el-button size="mini" @click="daoRu" type="primary"
              >导入excel</el-button
            >
            <el-button
              size="mini"
              @click="checkModify('DialogVisible')"
              type="danger"
              >批量修改选中</el-button
            >
            <el-button size="mini" type="success" @click="saveUpdate"
              >保存到基本库</el-button
            >
            <!--

          <el-button size="mini" class="info-btn" type="success">提交</el-button> -->
          </div>
        </div>
        <!-- 表格内容 -->
        <div id="loading-container" ref="contextmenuTargetRef">
          <ve-contextmenu
            :eventTarget="eventTarget"
            :options="rmOptions"
            @on-node-click="contextmenuClick"
          ></ve-contextmenu>
          <ve-table
            border-x
            border-y
            ref="goodstableRef"
            :columns="columns"
            :fixed-header="true"
            :scroll-width="1500"
            v-if="goodsDataShow"
            style="width: 100%; overflow: auto;"
            :style="`min-height:300px`"
            :maxHeight="`${tbmax_height}px`"
            rowKeyFieldName="rowKey"
            :table-data="goods_list"
            :editOption="editOption"
            :sort-option="sortOption"
            :checkbox-option="checkboxOption"
            :rowStyleOption="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :event-custom-option="eventCustomOption"
            :virtual-scroll-option="virtualScrollOption"
            :cellSelectionOption="cellSelectionOption"
            @filter-change="handleFilterChange"
            enable="true"
          />
        </div>
      </div>
    </div>

    <selectEdit
      ref="selectEditRef"
      who="goodsinfo"
      @bindDetermine="bindDetermine"
      @formatSalePrice="formatSalePrice"
    ></selectEdit>
    <wty-select-box
      ref="wtySelectBoxRef"
      :who="'goodsinfo'"
      @getReturn="wtyselectreturn"
    ></wty-select-box>
    <!-- 导入的组件 -->
    <excel
      ref="excel"
      @FileName="FileName"
      @cover-import="CoverTableData"
      @update-import="updateTableData"
    >
      更新并导入
    </excel>
  </div>
</template>
<script>
import dyhOnlineclass from "@/components/dyh-onlineclass.vue";
import dyhGoodsSearch from "@/components/dyh-goodsSearch.vue";
import {
  exportExcel
} from "@/js/exportExcel.js";
import excel from "@/components/excel.vue";
import selectEdit from "@/components/selectEdit.vue";
import { goodsInfoColumns, cellStyleOption } from "@/js/sheettablecolumn.js";
import wtySelectBox from "@/components/wty-selectBox.vue";

import {
  basegoodsGenerate,
  getBasegoodsInfo,
  basegoodsBatchquery,
  basegoodsModify
} from "@/api/goodsinfo.js";
const pinyin = require("js-pinyin");
export default {
  name: "goodsInfo",
  components: {
    excel,
    selectEdit,
    wtySelectBox,
    dyhOnlineclass,
    dyhGoodsSearch
  },
  data() {
    return {
      row_data: {},
      eventTarget: "",
      rmOptions: [
        {
          label: "新增一行",
          type: "addGoods"
        },
        {
          label: "删除选中",
          type: "deleteChecked"
        },
        {
          label: "导出",
          type: "exportXML"
        }
      ],
      loadingInstance: null,
      tbmax_height: 580,
      bulkModify: false,
      file_name: "",
      sub_data: {
        barcode: "",
        item_name: "",
        sub_name: "",
        sale_price: "",
        pym: "",
        class_id: "",
        unit: "",
        grade: "",
        product_area: "",
        item_size: "",
        life_day: "",
        brand_name: "",
        oper_id: "",
        merchant_id: "",
        oper_date: "",
        img: []
      },
      search_value: "",
      // 表格高度
      // 商品信息的展示
      goodsDataShow: true,
      checkedGoods: [],
      // 表头样式
      cellStyleOption: cellStyleOption,
      //是否开启单元格选择
      cellSelectionOption: {
        // disble cell selection
        enable: true
      },
      // 排序
      sortOption: {
        sortChange: params => {
          // console.log("sortChange::", params);
          this.sortChange(params);
        }
      },
      // 商品条码前复选框选中的值
      checkboxOption: {
        // hideSelectAll: true,
        // defaultSelectedRowKeys: ,
        // defaultSelectedAllRows:true,
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          // row选中行的数据 isSelected 选中的情况(true,false)
          if (isSelected === true) {
            this.checkedGoods.push(row.barcode);
          }
          if (isSelected === false) {
            for (var i = 0; i < this.checkedGoods.length; i++) {
              if (this.checkedGoods[i] === row.barcode) {
                this.checkedGoods.splice(i, 1);
              }
            }
          }
          /* console.log(this.checkedGoods.length);
          console.log(this.checkedGoods); */
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected === true) {
            this.checkedGoods = [];
            for (var i = 0; i < this.goods_list.length; i++) {
              this.checkedGoods[i] = this.goods_list[i].barcode;
            }
          } else {
            this.checkedGoods = [];
          }
        },
        radioList: [
          {
            label: "只保留数字",
            value: "0"
          } /* ,
        {
          label: "正常",
          value: "1"
        },
        {
          label: "休息",
          value: "2"
        } */
        ]
      },
      // 修改行样式
      // 表格自定义的单机事件
      eventCustomOption: {
        bodyCellEvents: ({ row, column, rowIndex }) => {
          return {
            click: event => {
              // console.log("click::", row, column, rowIndex, event);
            }
          };
        }
      },
      rowStyleOption: {
        clickHighlight: false,
        stripe: true
      },
      // 是否开启虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: false
      },
      // edit option 修改后的返回值
      editOption: {
        // cell value change
        cellValueChange: async ({ row, column }) => {
          /* console.log("cellValueChange row::", row);
          console.log("cellValueChange column::", column); */
          this.row_data = row;
          if (column.field === "barcode") {
            if (row.barcode.length < 5) {
              this.warnMessage("模糊查询请输入更具体一些，否则会造成卡顿");
              return;
            }
            this.loadingInstance.show();
            // 手动插入信息之后搜索商品
            const res = await getBasegoodsInfo(row.barcode, false);

            if (this.testR(res)) {
              this.loadingInstance.close();
              if (res.data.resp_data && res.data.resp_data.length === 0) {
                // 没有该商品应该 爆红
                row.class_state = "1";
                row.item_name = "";
                row.class_no = "";
                row.advise_price = "";
                this.warnMessage("库里未搜索到该商品！");
              } else if (res.data.resp_data && res.data.resp_data.length === 1) {
                this.wtySelectBoxRefGetReturn(res.data.resp_data[0]);
                // this.addGoods();
              } else if (res.data.resp_data && res.data.resp_data.length > 1) {
                this.$refs.wtySelectBoxRef.showDialog(res.data.resp_data);
              }
              //
            }
            this.loadingInstance.close();

            /* mdata.item_name = res.data.resp_data[0].item_name;
            mdata.class_no = res.data.resp_data[0].class_no; */
          }
        }
      },
      //TODO: 需要加上selectEdit 标题表格第一列的信息
      // table data 表格数据
      goods_list: [],
      allGoods_list: [],
      //表头
      columns: [],
      // 搜索框的值
      selectInput: ""
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.tbmax_height = newinner.innerHeight - 180;
        } else {
          this.tbmax_height = newinner.innerHeight - 195;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  created() {},
  mounted() {
    this.loadingInstance = this.$veLoading({
      target: "#loading-container",
      // 等同于
      // target:"#loading-container"
      overlayBackgroundColor: "rgba(255,255,255,.5)",
      name: "grid"
    });
    //TODO:

    // this.loadingInstance.show();
    this.eventTarget = this.$refs.contextmenuTargetRef;
    /* setTimeout(() => {
      this.addGoods();
    }, 100); */

    //表头信息
    this.columns = goodsInfoColumns;
  },
  destroyed() {
    this.loadingInstance.destroy();
  },
  methods: {
    handleFilterChange() {
      this.$nextTick(() => {
        this.$refs.selectEditRef.doLayout();
      });
    },
    //TODO: 搜索商品 选择多个 选择商品返回
    wtySelectBoxRefGetReturn(res) {
      for (let i = 0; i < this.goods_list.length; i++) {
        if (this.goods_list[i].barcode === res.barcode) {
          // console.log("重复添加")
          this.warnMessage("重复添加商品！");
          return;
        }
      }
      console.log("添加一行商品", res);
      this.row_data.barcode = res.barcode;
      this.row_data.item_name = res.item_name;
      // this.row_data.item_size = res.item_size;
      this.row_data.advise_price = res.advise_price;
      this.row_data.class_no = res.class_no ? res.class_no : "";
      this.row_data.class_state = "0";
      this.row_data.unit = res.unit;
      this.row_data.grade = res.grade;
      this.row_data.product_area = res.product_area;
      this.row_data.item_size = res.item_size;
      this.row_data.unit = res.unit;
      this.row_data.brand_name = res.brand_name;
      this.row_data.life_day = res.life_day;
      this.row_data.weight_flag = res.weight_flag;
      setTimeout(() => {
        this.addGoods();
      }, 100);
    },
    //创建或者是修改类别
    changeClass() {},
    //右键菜单点击事件
    contextmenuClick(e) {
      // console.log(e);
      this[e]();
    },

    /* init() {
      this.tbmax_height= window.innerHeigh-80;
    }, */
    tagChange(key) {},
    exportXML() {
      var data = [];
      for (var i = 0; i < this.goods_list.length; i++) {
        var dataitem = {};
        for (var key in this.goods_list[i]) {
          switch (key) {
            case "barcode":
              dataitem["商品条码"] = this.goods_list[i][key];
              break;
            case "item_name":
              dataitem["商品名称"] = this.goods_list[i][key];
              break;
            /*case "in_price":
              dataitem["进价"] = this.goods_list[i][key];
              break;
             case "qty":
              dataitem["入库"] = this.goods_list[i][key];
              break;
            case "sale_price":
              dataitem["售价"] = this.goods_list[i][key];
              break;
            case "vip_price":
              dataitem["会员价"] = this.goods_list[i][key];
              break; */
            case "advise_price":
              dataitem["建议售价"] = this.goods_list[i][key];
              break;
            case "vendor":
              dataitem["供应商"] = this.goods_list[i][key];
              break;
            case "class_no":
              dataitem["类别"] = this.goods_list[i][key];
              break;
            /* case "sup_no":
              dataitem["供应商"] = this.goods_list[i][key];
              break; */
            case "brand_name":
              dataitem["品牌"] = this.goods_list[i][key];
              break;
            case "product_area":
              dataitem["产地"] = this.goods_list[i][key];
              break;
            case "item_size":
              dataitem["规格"] = this.goods_list[i][key];
              break;
            case "unit":
              dataitem["单位"] = this.goods_list[i][key];
              break;
            case "grade":
              dataitem["等级"] = this.goods_list[i][key];
              break;
            case "life_day":
              dataitem["保质期"] = this.goods_list[i][key];
              break;
            case "weight_flag":
              dataitem["称重标识"] = this.goods_list[i][key];
              break;
          }
        }
        data.push(dataitem);
      }
      exportExcel(data, this.file_name);
    },
    //选中批量修改
    bindDetermine({ key, value }) {
      for (var i = 0; i < this.checkedGoods.length; i++) {
        for (var j = 0; j < this.goods_list.length; j++) {
          if (this.goods_list[j].barcode === this.checkedGoods[i]) {
            this.goods_list[j][key] = value;
          }
        }
      }
    },
    bindCancelTask() {
      this.DialogVisible = false;
      this.bulkModify = false;
    },
    //格式化售价时模态框显示
    checkModify(key) {
      this.$refs.selectEditRef.changeModal(key, true);
    },
    //排序
    sortChange(params) {
      this.goods_list.sort((a, b) => {
        if (params.barcode) {
          if (params.barcode === "asc") {
            return a.barcode - b.barcode;
          } else if (params.barcode === "desc") {
            return b.barcode - a.barcode;
          } else {
            return 0;
          }
        }
        if (params.index) {
          if (params.index === "asc") {
            return a.rowKey - b.rowKey;
          } else if (params.index === "desc") {
            return b.rowKey - a.rowKey;
          } else {
            return 0;
          }
        }
      });
    },
    // 显示或者隐藏model
    getGoods() {
      this.$refs.dyhgoodssearchRef.search(this.allGoods_list);
    },
    // 返回两个条件选择框的value值
    dyhGoodsSearchReturn(list) {
      console.log("dyh搜索返回：", list);
      this.goods_list = list;
      return;
      /* eslint-disable */
      if (this.allGoods_list == []) return;
      var that = this;
      // search_value;

      if (this.search_value == "" || this.search_value.length == 0) {
        this.loadingInstance.show();
        this.goods_list = [];
        this.goods_list = this.allGoods_list;
        this.loadingInstance.close();

        return;
      } else {
        this.loadingInstance.show();
        let list = this.allGoods_list.filter((item, index) => {
          return (
            item.item_name.indexOf(that.search_value) >= 0 ||
            String(item.barcode).indexOf(that.search_value) >= 0
          );
        });
        this.goods_list = [];
        this.goods_list = list;
        this.loadingInstance.close();
      }
      /* eslint-enable */
    },

    UploadUrl: function() {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    // 保存更改导入泰格软件
    //保存到基本库
    async saveUpdate() {
      //1、查询库里有没有该商品
      // console.log(this.goods_list);
      const goods_list = this.goods_list;

      if (this.goods_list.length === 0) {
        this.warnMessage("未发现任何商品信息！");
        return;
      }
      this.loadingInstance.show();
      var generatelist = [];
      var modifylist = [];
      var list = [];
      for (let i = 0; i < goods_list.length; i++) {
        if (goods_list[i].barcode) {
          goods_list[i].weight_flag = goods_list[i].weight_flag
            ? goods_list[i].weight_flag
            : "0";
          goods_list[i].item_subname = "";
          goods_list[i].item_name = goods_list[i].item_name
            .replace(/\s*/g, "")
            .slice(0, 15);
          goods_list[i].state = "0";
          goods_list[i].pym = pinyin.getCamelChars(goods_list[i].item_name);
          goods_list[i].flag = 0;
          goods_list[i].advise_price = goods_list[i].advise_price
            ? goods_list[i].advise_price
            : "0.00";
          list.push(goods_list[i].barcode);
        }
      }
      /* var have =[];
      var havenot =[]; */
      //批量查询商品信息看看库里有没有
      const res = await basegoodsBatchquery(list);
      if (
        res.data.return_code === "SUCCESS" &&
        res.data.result_code === "SUCCESS" &&
        res.data.resp_data
      ) {
        const relist = res.data.resp_data;
        for (let i = 0; i < relist.length; i++) {
          for (let j = 0; j < goods_list.length; j++) {
            // console.log(`relist[i].barcode ${relist[i].barcode} list[j].barcode ${goods_list[j].barcode} query_state ${relist[i].query_state}`  );
            if (
              relist[i].barcode === goods_list[j].barcode &&
              relist[i].query_state === "SUCCESS"
            ) {
              modifylist.push(basegoodsModify(goods_list[j]));
              break;
            } else if (
              relist[i].barcode === goods_list[j].barcode &&
              relist[i].query_state === "FAIL"
            ) {
              generatelist.push(basegoodsGenerate(goods_list[j]));
              break;
            }
          }
        }
      }
      //TODO: 创建失败、、 或者是修改失败 需要遍历数组
      if (generatelist.length > 0) {
        const [...gres] = await Promise.all(generatelist);
        if (this.testR(gres[0])) {
          this.successMessage("商品创建成功");
        }
      }
      if (modifylist.length > 0) {
        const [...mres] = await Promise.all(modifylist);
        if (this.testR(mres[0])) {
          this.successMessage("商品修改成功");
        }
      }
      this.loadingInstance.close();
    },
    /* coverbtn() {
      alert(1);
    },
    updatebtn() {
      alert(2);
    }, */
    // 树形控件的方法
    handleNodeClick(data) {
      console.log(data);
    },
    // 删除选中商品
    deleteChecked() {
      // console.log("选中的需要删除的商品",this.checkedGoods);
      if (this.checkedGoods.length === 0) {
        this.$message({
          type: "info",
          message: "没有被选中的商品"
        });
      } else {
        for (var j = 0; j <= this.checkedGoods.length; j++) {
          for (var i = 0; i < this.goods_list.length; i++) {
            if (this.goods_list[i].barcode === this.checkedGoods[j]) {
              this.goods_list.splice(i, 1);
            }
          }
        }
        this.checkedGoods = [];
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.setRowKey();
      }
    },
    //重新排序
    setRowKey() {
      this.goodsDataShow = false;
      for (let i = 0; i < this.goods_list.length; i++) {
        this.goods_list[i].rowKey = i;
      }
      this.$nextTick(() => {
        this.goodsDataShow = true;
      });
    },
    //格式化售价
    formatSalePrice(formatsp_data) {
      const array = [];
      for (let t = 0; t < formatsp_data.change_to.length; t++) {
        if (
          formatsp_data.change_to[t] !== "" ||
          formatsp_data.change_to[t].length !== 0
        ) {
          array.push(formatsp_data.change_to[t]);
        }
      }
      for (let i = 0; i < this.goods_list.length; i++) {
        let sale_price = (
          Number(this.goods_list[i].in_price) /
          (1 - Number(formatsp_data.point) / 100)
        ).toFixed(1);

        let afterdot = String(sale_price).substring(
          sale_price.indexOf(".") + 1
        );
        let beforedot = String(sale_price).slice(
          0,
          sale_price.indexOf(".") + 1
        );
        if (array.length !== 0) {
          if (!array.includes(afterdot)) {
            let y = 0;
            let temp = Math.abs(afterdot - array[0]);
            for (let x = 0; x < array.length; x++) {
              if (Math.abs(afterdot - array[x]) < temp) {
                temp = Math.abs(afterdot - array[x]);
                y = x;
              }
            }
            afterdot = array[y];
          }
        }

        this.goods_list[i].sale_price = beforedot + afterdot;
      }
      this.bulkModify = false;
    },
    // 添加一行
    addGoods() {
      // this.goodsDataShow = false;
      let a = this.goods_list.length;
      this.goods_list.push({
        barcode: "",
        item_name: "",
        class_no: "",
        brand_name: "",
        //sup_no: "",
        // in_price: "",
        // sale_price: "",
        product_area: "",
        unit: "",
        // vip_price: "",
        advise_price: "",
        weight_flag: "",
        grade: "",
        life_day: "",
        rowKey: a,
        class_state: "0"
      });
      setTimeout(() => {
        this.$refs.goodstableRef.scrollToRowKey({ rowKey: a });
      }, 100);
    },
    // 调用子组件的导入方法
    daoRu() {
      this.$refs.excel.showModel();
    },

    //TODO: 有问题
    wtyselectreturn(result) {
      //s删除选中的那一行
      this.checkedGoods.push(this.row_data.barcode);
      this.deleteChecked();
      //e
      //更新并导入所有数据
      this.updateTableData(result);

      /* var that = this;
      var res = [];
      for (let i = 0; i < result.length; i++) {
        if (
          String(JSON.stringify(this.goods_list)).indexOf(result[i].barcode) < 0
        ) {
          res.push(result[i]);
        }
      }
      if (res.length == 0 || res == []) {
        return;
      }
      //把第一行之外的交给更新并导入数据的函数
      var list = res.filter((item, index) => {
        return index > 0;
      });
      this.updateTableData(list);
      setTimeout(() => {
        that.wtySelectBoxRefGetReturn(res[0]);
      }); */
    },
    // 更新并导入获取表格组件的返回值
    updateTableData(val) {
      console.log(val);
      this.loadingInstance.show();
      // 只刷新表格内容
      this.goodsDataShow = false;
      this.$nextTick(() => {
        for (var i = 0; i < val.length; i++) {
          var _index = this.goods_list.findIndex(
            x => x.barcode === val[i].barcode
          );
          if (_index > -1) {
            // 遍历原来就有的对象的所有导入属性
            for (var key in val[i]) {
              this.goods_list[_index][key] = val[i][key];
            }
          } else {
            val[i].rowKey = this.goods_list.length;
            this.goods_list.push(val[i]);
          }
        }
        this.allGoods_list = [];
        this.allGoods_list = this.goods_list;
        this.goodsDataShow = true;
        console.log("所有商品", this.goods_list);
      });
      this.searchAGoods();
      setTimeout(() => {
        this.addGoods();
      }, 100);

      this.loadingInstance.close();
    },
    // 覆盖并导入数据
    CoverTableData(val) {
      // console.log(val);
      this.loadingInstance.show();
      this.goods_list = [];
      this.goodsDataShow = false;
      this.$nextTick(() => {
        for (var i = 0; i < val.length; i++) {
          var _index = this.goods_list.findIndex(
            x => x.barcode === val[i].barcode
          );
          if (_index > -1) {
            for (var key in val[i]) {
              this.goods_list[_index][key] = val[i][key];
            }
          } else {
            val[i].rowKey = this.goods_list.length;
            this.goods_list.push(val[i]);
          }
          this.$refs.excel.hiddleBox();
        }
        this.allGoods_list = [];
        this.allGoods_list = this.goods_list;
        this.goodsDataShow = true;
      });

      this.searchAGoods();
      setTimeout(() => {
        this.addGoods();
      }, 100);
      this.loadingInstance.close();
    },
    /**
     * 搜索所有商品信息
     * 赋予合适的样式
     */
    async searchAGoods() {
      //TODO: 导入的商品应该用线上还是线下的商品信息
      this.$nextTick(async () => {
        this.loadingInstance.show();
        var list = this.goods_list.map(item => {
          return item.barcode;
        });
        //批量查询商品信息看看库里有没有
        const res = await basegoodsBatchquery(list);
        console.log(res);
        if (
          this.testR &&
          res.data.return_code === "SUCCESS" &&
          res.data.result_code === "SUCCESS" &&
          res.data.resp_data
        ) {
          const relist = res.data.resp_data;
          for (let i = 0; i < relist.length; i++) {
            for (let j = 0; j < this.goods_list.length; j++) {
              if (
                relist[i].barcode === this.goods_list[j].barcode &&
                relist[i].query_state === "SUCCESS"
              ) {
                this.$set(this.goods_list[j], "class_state", "0");
                break;
              } else if (
                relist[i].barcode === this.goods_list[j].barcode &&
                relist[i].query_state === "FAIL"
              ) {
                this.$set(this.goods_list[j], "class_state", "1");
                break;
              }
            }
          }
          console.log(this.goods_list);
        }
        this.loadingInstance.close();
      });
    },
    FileName(file_name) {
      this.file_name = file_name;
    }
  }
};
</script>
<style scoped lang="less">
::v-deep .el-table__body{
    width: 100% !important;
}
.l-title {
  height: 40px;
  font-size: 20px;
  line-height: 2;
  padding: 0 0 10px 20px;
}
.el-button--mini {
  padding: 7px 5px;
}
.top-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 10px 0;
  height: 50px;
}
.body-aside {
  position: absolute;
  top: 10px;
  width: 20%;
  height: 93%;
  display: inline-block;
}

.thead {
  width: 100%;
  height: 25px;
  background-color: rgb(230, 230, 230);
}
.fa {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 5px 10px;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
}
.main-right {
  width: calc(100% - 230px);
}
.info-btn {
  width: 50px;
  text-align: center !important;
  // padding: 12px 10px 12px 10px;
}
.upload-btn {
  width: 120px;
  margin-left: -40px;
  background-color: #008effde;
  color: #fff;
}
.submit-btn {
  position: absolute;
  width: 100px;
  top: 146px;
  left: 127px;
  z-index: 6;
  background-color: #008effde;
  color: #fff;
}
.el-upload-list {
  width: 100px;
}
.drawer-head-div {
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 2;
  color: rgb(124, 124, 124);
}
.drawer-head-div > i {
  display: inline-block;
  text-align: center;
  width: 28%;
  cursor: pointer;
}
.drawer-head-div-i {
  /* border-bottom: 4px solid #0c9d72; */
  /* background-color: ; */
  color: rgb(124, 124, 124);
  font-weight: 700;
}
.el-tree-node__content > .el-tree-node__label {
  font-size: 18px !important;
}
.ve-table-fixed-header .ve-table-header {
  background-color: #91d5ff !important;
  color: #fff !important;
}
.ve-table {
  padding: 2px !important;
  font-size: 2px;
}
.demo-drawer__footer {
  width: 100%;
  position: absolute;
  bottom: 10px;
  left: 60px;
}
.demo-drawer__footer > .el-button {
  display: inline-block;
  width: 40%;
}
.footer-btn {
  display: inline-block;
  width: 40%;
  /* margin-left: 40px; */
}
.el-input-select {
  width: 120px;
}
.right-select {
  margin: 30px 0 0 0;
}
.el-form-select {
  margin-left: -20px;
}
.select-right-drawer {
  width: 440px;
}
</style>
